import React, { useState, useEffect, useRef } from 'react'
import cn from 'classnames'
import { useSelector } from 'react-redux'
import { VolumePicker } from './VolumePicker'
import { ReactComponent as SpeakersIcon } from 'assets/svg/shared/sound.svg'
import { ReactComponent as MuteIcon } from 'assets/svg/shared/mute.svg'

function useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible)
    const ref = useRef(null)

    const handleClickOutside = (event) => {
        ref.current && ref.current.contains(event.target) ? setIsComponentVisible(true) : setIsComponentVisible(false)
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true)
        return () => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    })

    return { ref, isComponentVisible, setIsComponentVisible }
}
export const Speakers = () => {
    const [isVolumePickerShown, setVolumePickerShown] = useState(false)
    const volume = useSelector((state) => state.settings.volume)
    const { ref, isComponentVisible } = useComponentVisible(true)

    useEffect(() => {
        if (!isComponentVisible) {
            setVolumePickerShown(false)
        }
    }, [isComponentVisible, isVolumePickerShown])

    const switcherPickerVisibility = () => {
        setVolumePickerShown(!isVolumePickerShown)
    }
    return (
        <div className="app__header__img-speakers__wrapper" ref={ref}>
            <button type="button" onClick={switcherPickerVisibility}>
                {volume > 0 ? (
                    <SpeakersIcon
                        className={cn(
                            'app__header__img-speakers',
                            isVolumePickerShown && 'app__header__img-speakers--active'
                        )}
                    />
                ) : (
                    <MuteIcon
                        className={cn(
                            'app__header__img-speakers',
                            isVolumePickerShown && 'app__header__img-speakers--active'
                        )}
                    />
                )}
            </button>
            {isComponentVisible && isVolumePickerShown && (
                <div className="app__header__vol-picker__wrapper d-flex flex-column align-items-center">
                    <VolumePicker />
                </div>
            )}
        </div>
    )
}
